import React from 'react';
import PropTypes from 'prop-types';

function Tick({ className = 'icon-tick', ...props }) {
  return (
    <svg
      width="21px"
      height="20px"
      viewBox="0 0 21 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="RegModal_specs" transform="translate(-1548.000000, -797.000000)" fill="#29A61B">
          <polyline
            id="Shape-Copy-2"
            points="1556.72973 816.55 1548 805.44027 1549.80568 804.020541 1556.50919
          812.552703 1566.21297 797 1568.16108 798.217568 1556.72514 816.55"
          />
        </g>
      </g>
    </svg>
  );
}

Tick.propTypes = {
  className: PropTypes.string,
};

export default Tick;
